import firebase from "firebase";
import {firebaseConfig} from "../FIREBASE_CONFIG";
import StationAdoptStore from "../stationadopt/StationAdoptStore";
import StationSetupStore from "./StationSetupStore";
import StationsStore from "./StationsStore";
import {createFileNameTimeStamp} from "../../framework/util/forms/DateUtils";
import {parseAllDatesDoc} from "../../framework/util/firebase/FireStoreUtils";

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.apps[0];
const db = firebase.firestore();
const collectionPath = 'presspalletbuilder';
const DEFAULT_HOURS = 48;


export const getCurrentPressPallet = async () => {
    return getCurrentPressPallets(1);
}

export const getCurrentPressPallets = async (limit = 100) => {

    const adoptInfo = await new StationAdoptStore().read();
    if (!adoptInfo?.data?.stationId)
        throw 'Station not assigned';

    const stationId = adoptInfo.data.stationId;

    var beginningDate = Date.now() - DEFAULT_HOURS * 60 * 60 * 1000;
    var beginningDateObject = new Date(beginningDate);

    const result = await getPressPalletsBetween(stationId, beginningDateObject, null,limit);

    return result;

}

export const getPressPalletsBetween = async (stationId, startDate, endDate, limit) => {


    console.log('Searching for press pallet manifests on ' + stationId + ' between ' + startDate + ' and ' + endDate);

    const station = await new StationsStore().findById(stationId);
    if (!station?.data?.siteId)
        throw 'Station not found ' + stationId;

    const siteId = station.data.siteId;

    var jobs = [];

    console.log('Querying for pallets on station', {stationId, startDate, endDate, limit});
    var ref;
    if (endDate) ref= db.collection(collectionPath)
        .where("stationId", "==", stationId)
        .where('loadTime', '>=', startDate)
        .where('loadTime', '<=', endDate)
        .orderBy('loadTime', "desc")
        .limit(limit);
    else
        ref= db.collection(collectionPath)
            .where("stationId", "==", stationId)
            .where('loadTime', '>=', startDate)
            .orderBy('loadTime', "desc")
            .limit(limit);

    try {
        var snasphot = await ref.get();
        for(const doc of snasphot.docs){
            const job = {id: doc.id, ...doc.data()};
            parseAllDatesDoc(job);
            jobs.push(job);
        }
    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }

    return {data: jobs};

}

export const getLastTwoAutoPalletsForStation = async (stationId) => {

    console.log('Searching pallets on ' + stationId);

    var pallets = [];

    var ref= db.collection(collectionPath)
        .where("stationId", "==", stationId)
        .where("createType", "==", "auto")
        .orderBy('loadTime', "desc")
        .limit(2);

    try {
        var snasphot = await ref.get();
        for(const doc of snasphot.docs){
            const pallet = {id: doc.id, ...doc.data()};
            parseAllDatesDoc(pallet);
            pallets.push(pallet);
        }
    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }

    return pallets;

}


export const getCurrentAutoPalletForStation = async (stationId) => {


    const pallets = await getLastTwoAutoPalletsForStation((stationId));

    if (pallets.length > 0)
        return pallets[0];
    else
        return null;

}

export const getLastAutoPalletForStation = async (stationId) => {


    const pallets = await getLastTwoAutoPalletsForStation((stationId));

    if (pallets.length > 1)
        return pallets[1];
    else
        return null;

}


export const findById = async (id) => {

    if (!id)
        throw 'No pallet id';

    console.log('findById', {id})
    const ref = db.collection(collectionPath).doc(id);

    try {
        const doc = await ref.get();

        if (!doc.exists)
            return null;
        else {
            const job = doc.data();
            parseAllDatesDoc(job);
            return (job);
        }

    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }


}

export const save = async(values) => {


    if (!values.id) {
        const id = await createId(values.stationId);
        values.id = id;
    }

    // strip out the press jobs
    const pressJobIds = [];
    values.jobs.forEach((job)=> {
        pressJobIds.push({id: job.jobUniqueId});
    });
    values.jobs = pressJobIds;
    const res = await db.collection(collectionPath).doc(values.id).set(values);
    return values;
}

export const deleteBulk = async (pallets) => {
    pallets.forEach(async pallet=>await deleteSingle(pallet));
}

export const deleteSingle = async (pallet) => {
   await db.collection(collectionPath).doc(pallet.id).delete();

}


export const createId = async (stationId) => {

    const stationData = await (new StationsStore().findById(stationId));
    const station = stationData.data;
    const id = station.siteId + "-"  + station.name + "-" + createFileNameTimeStamp(new Date());

    return id;
}

export const createNew = async ({loadOperatorId, stationId, palletId, ...values}) => {

    if (!stationId)
        throw 'No station id';

    const stationData = await (new StationsStore().findById(stationId));
    const station = stationData.data;
    const id = await createId(stationId);
    console.log('Creating pallet ' + id, {loadOperatorId, stationId, palletId, ...values});

    if (!loadOperatorId)
        throw 'no loadOperatorId';

    if (!palletId)
        throw 'no palletId';

    const data = {id: id, loadOperatorId: loadOperatorId, stationId: stationId, palletId: palletId, ...values};
    const res = await db.collection(collectionPath).doc(id).set(data);
    console.log('Created pallet', {loadOperatorId, stationId, palletId, ...values});

    return data;

}
